import { Box, BoxProps, Collapse } from "@mui/material";
import clsx from "clsx";
import { ReactNode, useState } from "react";
import { createUseStyles } from "$utils/createUseStyles";
import Text from "$components/Text";
import { theme } from "$utils/theme/bataillog";

type Props = {
  defaultHeight?: number;
  children?: ReactNode;
  isVisible?: boolean;
} & BoxProps;

function Collapsible({
  defaultHeight = 0,
  children,
  isVisible = true,
  ...boxProps
}: Props) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      {...boxProps}
      className={clsx(boxProps?.className, classes.collapsibleContainer)}
    >
      <Collapse in={expanded} collapsedSize={defaultHeight}>
        {children}
      </Collapse>
      {isVisible && (
        <Text
          type="important"
          onClick={handleClick}
          className={classes.actionText}
        >
          {expanded ? "Afficher moins" : "Afficher plus"}
        </Text>
      )}
    </Box>
  );
}

const useStyles = createUseStyles(() => ({
  collapsibleContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  actionText: {
    color: theme.color.blueLight,
    alignSelf: "flex-end",
    cursor: "pointer",
    paddingTop: "10px",
    marginRight: "16px",
  },
}));

export default Collapsible;
